import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { ILeadState } from './lead.state';

export class LeadSelectors {
  static readonly leadState = (state: IRootState): ILeadState => {
    return state.lead as ILeadState;
  };

  static readonly model = createSelector(LeadSelectors.leadState, (lead: ILeadState) => {
    return lead.model;
  });

  static readonly data = createSelector(LeadSelectors.leadState, (lead: ILeadState) => {
    return lead.data;
  });
}
